// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"mainInbox_filterContainer__2VxEi","threadContainer":"mainInbox_threadContainer__1QMSy","hide":"mainInbox_hide__2Vp_t"};